import { useState } from "react";
import { useLang } from "../context/LanguageContext";
import { Plus, Minus } from "lucide-react";

const FaqItem = ({ item, isOpen, onToggle, index }) => {
  return (
    <div className="border-b border-[#0A1128]/10" data-testid={`faq-item-${index}`}>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex items-center justify-between gap-6 py-6 text-left group"
        aria-expanded={isOpen}
        data-testid={`faq-toggle-${index}`}
      >
        <span className="font-serif-display text-lg md:text-xl text-[#0A1128] group-hover:text-[#C5A059] transition-colors">
          {item.q}
        </span>
        <span className="flex-shrink-0 w-9 h-9 grid place-items-center border border-[#0A1128]/15 group-hover:border-[#C5A059] group-hover:bg-[#C5A059]/10 transition-all">
          {isOpen ? (
            <Minus size={14} strokeWidth={1.5} className="text-[#C5A059]" />
          ) : (
            <Plus size={14} strokeWidth={1.5} className="text-[#0A1128]" />
          )}
        </span>
      </button>
      <div
        className={`grid transition-all duration-300 ease-in-out ${
          isOpen ? "grid-rows-[1fr] opacity-100 pb-6" : "grid-rows-[0fr] opacity-0"
        }`}
      >
        <div className="overflow-hidden">
          <p className="text-[#3A435E] leading-relaxed max-w-3xl font-light">{item.a}</p>
        </div>
      </div>
    </div>
  );
};

const FAQSection = () => {
  const { t } = useLang();
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <section className="border-t border-[#0A1128]/10 bg-[#FCFAF8]" data-testid="faq-section" id="faq">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-10">
        <div className="md:col-span-4">
          <div className="overline mb-3">{t.faq.overline}</div>
          <h2 className="font-serif-display text-3xl md:text-5xl font-light leading-tight text-[#0A1128]">
            {t.faq.title}
          </h2>
        </div>
        <div className="md:col-span-8">
          {t.faq.items.map((item, i) => (
            <FaqItem
              key={`faq-${item.q?.slice(0, 30) || i}`}
              index={i}
              item={item}
              isOpen={openIndex === i}
              onToggle={() => setOpenIndex(openIndex === i ? -1 : i)}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default FAQSection;
